import { Badge, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReceiptsListSideActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-right: auto;
`

export const ButtonsGroupWrapper = styled.div`
  margin-left: auto;
`

export const BadgeWrapper = styled(Badge)`
  margin-left: ${Spacing.S8};
`
